var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.value,
        fullscreen: "",
        persistent: "",
        "no-click-animation": "",
        transition: "dialog-bottom-transition",
      },
      on: { input: _vm.onDialogInput },
    },
    [
      _c("v-card", { staticClass: "d-flex flex-column ai-builder-card" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex align-center px-4 primary white--text ai-builder-toolbar",
          },
          [
            _c("v-icon", { staticClass: "mr-2", attrs: { color: "white" } }, [
              _vm._v("mdi-creation"),
            ]),
            _c("div", { staticClass: "text-subtitle-1 font-weight-medium" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$vuetify.lang.t(
                      "$vuetify.SITE_BUILDER.AI_BUILDER.DIALOG_TITLE"
                    )
                  ) +
                  " "
              ),
            ]),
            _c("v-spacer"),
            _c(
              "v-btn",
              {
                attrs: {
                  icon: "",
                  "aria-label": _vm.$vuetify.lang.t(
                    "$vuetify.SITE_BUILDER.AI_BUILDER.CLOSE"
                  ),
                },
                on: { click: _vm.close },
              },
              [
                _c("v-icon", { attrs: { color: "white" } }, [
                  _vm._v("mdi-close"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "ai-builder-frame-wrap" },
          [
            _vm.value && !_vm.ready
              ? _c("v-progress-linear", {
                  attrs: {
                    indeterminate: "",
                    color: "primary",
                    absolute: "",
                    top: "",
                  },
                })
              : _vm._e(),
            _vm.handshakeFailed
              ? _c(
                  "div",
                  { staticClass: "ai-builder-handshake-error px-4 py-3" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$vuetify.lang.t(
                            "$vuetify.SITE_BUILDER.AI_BUILDER.HANDSHAKE_FAILED"
                          )
                        ) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
            _vm.value
              ? _c("iframe", {
                  ref: "frame",
                  staticClass: "ai-builder-frame",
                  attrs: {
                    name: _vm.iframeName,
                    src: _vm.embedUrl,
                    title: _vm.$vuetify.lang.t(
                      "$vuetify.SITE_BUILDER.AI_BUILDER.DIALOG_TITLE"
                    ),
                    sandbox:
                      "allow-scripts allow-same-origin allow-forms allow-popups",
                    allow: "clipboard-read; clipboard-write",
                  },
                  on: { load: _vm.onFrameLoad },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }